import React from "react";
import { Modal } from "antd";
import { RxCross1 } from "react-icons/rx";
import errorImage from "../../assets/Svg/errorImage.svg";
import { useNavigate } from "react-router-dom";

const CustomModal = ({
  text,
  image,
  heading,
  icons,
  showIcons,
  showModal,
  setShowModal,
  isErrorModal,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setShowModal(false);
    navigate(-1);
  };
  return (
    <div className=" flex justify-center items-center">
      <Modal
        title={
          <div className="flex justify-center items-center text-[#425462] text-base font-normal">
            {" "}
            {heading}
          </div>
        }
        open={showModal}
        onCancel={handleClose}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        closeIcon={<RxCross1 color="#F31260" size={18} />}
        centered
      >
        {isErrorModal ? (
          <div>
            <div className="flex justify-center items-center py-10">
              <img src={errorImage} alt="icon" />
            </div>
            <div className="flex justify-center items-center text-[#425462] text-lg font-normal">
              Something went wrong.
            </div>
            <div className="flex justify-center items-center text-[#425462] text-sm font-light">
              Please give it another try.
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </Modal>
    </div>
  );
};

export default CustomModal;
